import * as React from "react";
import { Component } from "react";
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock } from "react-bootstrap";
import CurrencyInput from "react-currency-input";
import DividerLine from "src/components/common/DividerLine";
import LoadingStatus from "src/components/common/LoadingStatus";
import { TIMEOUT } from "src/global";
import { IBaseState } from "src/interfaces";
import { IStatementSummaryProps } from "./interfaces";

export default class StatementSummary extends Component<IStatementSummaryProps, IBaseState> {
  public constructor(props: IStatementSummaryProps) {
    super(props);

    this.state = {
      loading: true,
    };

    this.handleStatementDateChanged = this.handleStatementDateChanged.bind(this);
    this.handleYearsWithSolarChanged = this.handleYearsWithSolarChanged.bind(this);
    this.handleTotalAmountDueChanged = this.handleTotalAmountDueChanged.bind(this);
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, TIMEOUT);
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset>
          <legend>Statement Summary</legend>
          <LoadingStatus singular={true} width={25} height={25} type="Watch" />
        </fieldset>
      );
    }

    const xsLabelWidthL = 6;
    const xsInputWidthL = 6;
    const smLabelWidthL = 6;
    const smInputWidthL = 6;
    const mdLabelWidthL = 6;
    const mdInputWidthL = 6;

    const readOnly = this.props.match.params.priorId !== undefined;

    return (
      <fieldset className="fieldset-left">
        <legend>Statement Summary</legend>
        <FormGroup bsSize="small" controlId="advstatementDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Statement Date
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              autoFocus={true}
              bsSize="small"
              type="date"
              value={new Date(this.props.statementDate).toISOString().substring(0, 10)}
              onChange={this.handleStatementDateChanged}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthL}
          smOffset={smLabelWidthL}
          mdOffset={mdLabelWidthL}
          xs={xsInputWidthL}
          sm={smInputWidthL}
          md={mdInputWidthL}
        />
        <FormGroup bsSize="small" controlId="serviceStartDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Service Start
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.serviceStartDate).toISOString().substring(0, 10)}
              onChange={this.props.serviceStartDateChanged}
              readOnly={readOnly}
              tabIndex={readOnly ? -1 : undefined}
            />
            <HelpBlock>All Last Read Dates</HelpBlock>
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="serviceEndDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Service End
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.serviceEndDate).toISOString().substring(0, 10)}
              onChange={this.props.serviceEndDateChanged}
            />
            <HelpBlock>All Read Dates</HelpBlock>
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthL}
          smOffset={smLabelWidthL}
          mdOffset={mdLabelWidthL}
          xs={xsInputWidthL}
          sm={smInputWidthL}
          md={mdInputWidthL}
        />
        <FormGroup bsSize="small" controlId="advyearsWithSolar">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Years with Solar
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.yearsWithSolar}
              onChange={this.handleYearsWithSolarChanged}
            />
            <HelpBlock>(Optional)</HelpBlock>
          </Col>
        </FormGroup>
        {this.props.showNetElectricityCredit ? (
          <FormGroup bsSize="small" controlId="advtotalAmountDue">
            <Col
              xs={xsLabelWidthL}
              sm={smLabelWidthL}
              md={mdLabelWidthL}
              componentClass={ControlLabel}
            >
              Cost of Electricity
            </Col>
            <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
              <CurrencyInput
                className="currency-input form-control input-sm"
                value={this.props.totalAmountDue}
                precision={2}
                prefix={"$"}
                inputType="text"
                tabIndex={-1}
                readOnly={true}
              />
            </Col>
          </FormGroup>
        ) : null}
        {this.props.showNetElectricityCredit ? (
          <FormGroup bsSize="small" controlId="netElectricityCredit">
            <Col
              xs={xsLabelWidthL}
              sm={smLabelWidthL}
              md={mdLabelWidthL}
              componentClass={ControlLabel}
            >
              Net Electricity Credit
            </Col>
            <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
              <CurrencyInput
                className="currency-input form-control input-sm"
                value={this.props.netElectricityCredit}
                precision={2}
                prefix={"$"}
                inputType="text"
                tabIndex={-1}
                readOnly={true}
                allowNegative={true}
              />
            </Col>
          </FormGroup>
        ) : null}
        {this.props.showNetElectricityCredit ? (
          <FormGroup bsSize="small" controlId="totalCharges">
            <Col
              xs={xsLabelWidthL}
              sm={smLabelWidthL}
              md={mdLabelWidthL}
              componentClass={ControlLabel}
            >
              Total Charges
            </Col>
            <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
              <CurrencyInput
                className="currency-input form-control input-sm"
                value={this.props.totalAmountDue + this.props.netElectricityCredit}
                precision={2}
                prefix={"$"}
                inputType="text"
                tabIndex={-1}
                readOnly={true}
                allowNegative={true}
              />
            </Col>
          </FormGroup>
        ) : null}
        {!this.props.showNetElectricityCredit ? (
          <FormGroup bsSize="small" controlId="advtotalAmountDue">
            <Col
              xs={xsLabelWidthL}
              sm={smLabelWidthL}
              md={mdLabelWidthL}
              componentClass={ControlLabel}
            >
              Amount Due
            </Col>
            <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
              <CurrencyInput
                className="currency-input form-control input-sm"
                value={this.props.totalAmountDue}
                precision={2}
                prefix={"$"}
                inputType="text"
                tabIndex={-1}
                readOnly={true}
              />
            </Col>
          </FormGroup>
        ) : null}
      </fieldset>
    );
  }

  private handleStatementDateChanged(e: any) {
    this.props.statementDateChanged(e);
  }
  private handleYearsWithSolarChanged(e: any) {
    this.props.yearsWithSolarChanged(e);
  }
  private handleTotalAmountDueChanged(e: any) {
    this.props.totalAmountDueChanged(e);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/StatementSummary.tsx